export enum CustomizerEvents {
  ConfigurationLoaded = 'customizer-configuration-load',
  FamilyLoaded = 'customizer-family-load',
  FindRetailerClick = 'customizer-find-retailer-click',
  GroupsLoaded = 'customizer-groups-load',
  GroupsProcessed = 'customizer-groups-process',
  SelectionChanged = 'customizer-selection-change',
  SelectionPriceLoaded = 'customizer-selection-price-load',
}
